// source: page_scale.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.LengthUnit', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PagePoint', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleAction', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleStatus', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteOutcome', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.KindCase', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.Code', null, global);
goog.exportSymbol('proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PagePoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.oneofGroups_);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.displayName = 'proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject = function(includeInstance, msg) {
  var f, obj = {
x: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
y: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
  return proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setX(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setY(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getX();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getY();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double x = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.prototype.getX = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.prototype.setX = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double y = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.prototype.getY = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.prototype.setY = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.KindCase = {
  KIND_NOT_SET: 0,
  PAGE: 1,
  DRAWING_VIEW: 2
};

/**
 * @return {proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.KindCase}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.getKindCase = function() {
  return /** @type {proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.KindCase} */(jspb.Message.computeOneofCase(this, proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.toObject = function(includeInstance, msg) {
  var f, obj = {
page: (f = msg.getPage()) && proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.toObject(includeInstance, f),
drawingView: (f = msg.getDrawingView()) && proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope;
  return proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.deserializeBinaryFromReader);
      msg.setPage(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.deserializeBinaryFromReader);
      msg.setDrawingView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPage();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.serializeBinaryToWriter
    );
  }
  f = message.getDrawingView();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.serializeBinaryToWriter
    );
  }
};


/**
 * optional PageWideScope page = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.getPage = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.setPage = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.clearPage = function() {
  return this.setPage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.hasPage = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DrawingViewScope drawing_view = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.getDrawingView = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.setDrawingView = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.clearDrawingView = function() {
  return this.setDrawingView(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.prototype.hasDrawingView = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope;
  return proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageWideScope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.toObject = function(includeInstance, msg) {
  var f, obj = {
viewId: jspb.Message.getFieldWithDefault(msg, 1, ""),
topLeft: (f = msg.getTopLeft()) && proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(includeInstance, f),
bottomRight: (f = msg.getBottomRight()) && proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope;
  return proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setViewId(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader);
      msg.setTopLeft(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader);
      msg.setBottomRight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getViewId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTopLeft();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter
    );
  }
  f = message.getBottomRight();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter
    );
  }
};


/**
 * optional string view_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.getViewId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.setViewId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PagePoint top_left = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.getTopLeft = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.setTopLeft = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.clearTopLeft = function() {
  return this.setTopLeft(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.hasTopLeft = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PagePoint bottom_right = 3;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.getBottomRight = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, 3));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.setBottomRight = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.clearBottomRight = function() {
  return this.setBottomRight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.DrawingViewScope.prototype.hasBottomRight = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.toObject = function(includeInstance, msg) {
  var f, obj = {
scaleText: jspb.Message.getFieldWithDefault(msg, 1, ""),
drawingScaleFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
source: jspb.Message.getFieldWithDefault(msg, 3, 0),
detectorVersion: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate;
  return proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScaleText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDrawingScaleFactor(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetectorVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScaleText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDrawingScaleFactor();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDetectorVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string scale_text = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.getScaleText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.setScaleText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double drawing_scale_factor = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.getDrawingScaleFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.setDrawingScaleFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional ScaleSource source = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.getSource = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string detector_version = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.getDetectorVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.prototype.setDetectorVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.toObject = function(includeInstance, msg) {
  var f, obj = {
start: (f = msg.getStart()) && proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(includeInstance, f),
end: (f = msg.getEnd()) && proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(includeInstance, f),
coordinateSystem: jspb.Message.getFieldWithDefault(msg, 3, ""),
enteredValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
enteredUnit: jspb.Message.getFieldWithDefault(msg, 5, 0),
knownLengthInches: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
normalizedValue: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance;
  return proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoordinateSystem(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnteredValue(value);
      break;
    case 5:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.LengthUnit} */ (reader.readEnum());
      msg.setEnteredUnit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setKnownLengthInches(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNormalizedValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter
    );
  }
  f = message.getCoordinateSystem();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEnteredValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEnteredUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getKnownLengthInches();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getNormalizedValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional PagePoint start = 1;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getStart = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, 1));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.hasStart = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PagePoint end = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getEnd = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string coordinate_system = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getCoordinateSystem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setCoordinateSystem = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string entered_value = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getEnteredValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setEnteredValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional LengthUnit entered_unit = 5;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.LengthUnit}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getEnteredUnit = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.LengthUnit} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.LengthUnit} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setEnteredUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional double known_length_inches = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getKnownLengthInches = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setKnownLengthInches = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional string normalized_value = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.getNormalizedValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.prototype.setNormalizedValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.toObject = function(includeInstance, msg) {
  var f, obj = {
widthPoints: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
heightPoints: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
pageSizeCorrectionFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
geometryVersion: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry;
  return proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setWidthPoints(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeightPoints(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPageSizeCorrectionFactor(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setGeometryVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWidthPoints();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getHeightPoints();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getPageSizeCorrectionFactor();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getGeometryVersion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional double width_points = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.getWidthPoints = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.setWidthPoints = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double height_points = 2;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.getHeightPoints = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.setHeightPoints = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double page_size_correction_factor = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.getPageSizeCorrectionFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.setPageSizeCorrectionFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string geometry_version = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.getGeometryVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.prototype.setGeometryVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.toObject = function(includeInstance, msg) {
  var f, obj = {
code: jspb.Message.getFieldWithDefault(msg, 1, 0),
message: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning;
  return proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.Code} */ (reader.readEnum());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.Code = {
  CODE_UNSPECIFIED: 0,
  DIFFERS_FROM_AUTOMATIC: 1,
  OUTSIDE_PLAUSIBLE_BOUNDS: 2
};

/**
 * optional Code code = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.Code}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.prototype.getCode = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.Code} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.Code} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.prototype.setCode = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.repeatedFields_ = [15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.toObject = function(includeInstance, msg) {
  var f, obj = {
calibrationId: jspb.Message.getFieldWithDefault(msg, 1, ""),
projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 3, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 4, 0),
pageRevision: jspb.Message.getFieldWithDefault(msg, 5, ""),
scope: (f = msg.getScope()) && proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.toObject(includeInstance, f),
source: jspb.Message.getFieldWithDefault(msg, 7, 0),
reference: (f = msg.getReference()) && proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.toObject(includeInstance, f),
referenceLengthPoints: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
realInchesPerPoint: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
drawingScaleFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
geometry: (f = msg.getGeometry()) && proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.toObject(includeInstance, f),
automaticCandidate: (f = msg.getAutomaticCandidate()) && proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.toObject(includeInstance, f),
differenceFromAutomaticPercent: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
acknowledgedWarningsList: jspb.Message.toObjectList(msg.getAcknowledgedWarningsList(),
    proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.toObject, includeInstance),
note: jspb.Message.getFieldWithDefault(msg, 16, ""),
createdBy: jspb.Message.getFieldWithDefault(msg, 17, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
schemaVersion: jspb.Message.getFieldWithDefault(msg, 19, ""),
algorithmVersion: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration;
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCalibrationId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPageRevision(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.deserializeBinaryFromReader);
      msg.setScope(value);
      break;
    case 7:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 8:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.deserializeBinaryFromReader);
      msg.setReference(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferenceLengthPoints(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRealInchesPerPoint(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDrawingScaleFactor(value);
      break;
    case 12:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.deserializeBinaryFromReader);
      msg.setGeometry(value);
      break;
    case 13:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.deserializeBinaryFromReader);
      msg.setAutomaticCandidate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDifferenceFromAutomaticPercent(value);
      break;
    case 15:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.deserializeBinaryFromReader);
      msg.addAcknowledgedWarnings(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaVersion(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAlgorithmVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCalibrationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageRevision();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getScope();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.serializeBinaryToWriter
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getReference();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance.serializeBinaryToWriter
    );
  }
  f = message.getReferenceLengthPoints();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getRealInchesPerPoint();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getDrawingScaleFactor();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getGeometry();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry.serializeBinaryToWriter
    );
  }
  f = message.getAutomaticCandidate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.serializeBinaryToWriter
    );
  }
  f = message.getDifferenceFromAutomaticPercent();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getAcknowledgedWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.serializeBinaryToWriter
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSchemaVersion();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getAlgorithmVersion();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional string calibration_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getCalibrationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setCalibrationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string file_id = 3;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int32 page_number = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string page_revision = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getPageRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setPageRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional ScaleScope scope = 6;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getScope = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope, 6));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setScope = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.clearScope = function() {
  return this.setScope(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.hasScope = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional ScaleSource source = 7;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getSource = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional ReferenceDistance reference = 8;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getReference = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance, 8));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.ReferenceDistance|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setReference = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.clearReference = function() {
  return this.setReference(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.hasReference = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double reference_length_points = 9;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getReferenceLengthPoints = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setReferenceLengthPoints = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double real_inches_per_point = 10;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getRealInchesPerPoint = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setRealInchesPerPoint = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double drawing_scale_factor = 11;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getDrawingScaleFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setDrawingScaleFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional PageGeometry geometry = 12;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getGeometry = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry, 12));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PageGeometry|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setGeometry = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.clearGeometry = function() {
  return this.setGeometry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.hasGeometry = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional AutomaticScaleCandidate automatic_candidate = 13;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getAutomaticCandidate = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate, 13));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setAutomaticCandidate = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.clearAutomaticCandidate = function() {
  return this.setAutomaticCandidate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.hasAutomaticCandidate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional double difference_from_automatic_percent = 14;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getDifferenceFromAutomaticPercent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setDifferenceFromAutomaticPercent = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * repeated ScaleWarning acknowledged_warnings = 15;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning>}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getAcknowledgedWarningsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning, 15));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning>} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setAcknowledgedWarningsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.addAcknowledgedWarnings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.clearAcknowledgedWarningsList = function() {
  return this.setAcknowledgedWarningsList([]);
};


/**
 * optional string note = 16;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string created_by = 17;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string schema_version = 19;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getSchemaVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setSchemaVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string algorithm_version = 20;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.getAlgorithmVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.prototype.setAlgorithmVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
status: jspb.Message.getFieldWithDefault(msg, 4, 0),
calibration: (f = msg.getCalibration()) && proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.toObject(includeInstance, f),
revision: jspb.Message.getFieldWithDefault(msg, 6, 0),
etag: jspb.Message.getFieldWithDefault(msg, 7, ""),
currentPageRevision: jspb.Message.getFieldWithDefault(msg, 8, ""),
message: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState;
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.deserializeBinaryFromReader);
      msg.setCalibration(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRevision(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEtag(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPageRevision(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCalibration();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.serializeBinaryToWriter
    );
  }
  f = message.getRevision();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getEtag();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCurrentPageRevision();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional PageScaleStatus status = 4;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleStatus}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getStatus = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleStatus} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional PageScaleCalibration calibration = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getCalibration = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setCalibration = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.clearCalibration = function() {
  return this.setCalibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.hasCalibration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 revision = 6;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string etag = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getEtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setEtag = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string current_page_revision = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getCurrentPageRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setCurrentPageRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string message = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest;
  return proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.GetPageScaleCalibrationRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
scope: (f = msg.getScope()) && proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.toObject(includeInstance, f),
start: (f = msg.getStart()) && proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(includeInstance, f),
end: (f = msg.getEnd()) && proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.toObject(includeInstance, f),
coordinateSystem: jspb.Message.getFieldWithDefault(msg, 7, ""),
enteredValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
note: jspb.Message.getFieldWithDefault(msg, 9, ""),
automaticCandidate: (f = msg.getAutomaticCandidate()) && proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.toObject(includeInstance, f),
expectedEtag: jspb.Message.getFieldWithDefault(msg, 11, ""),
expectedPageRevision: jspb.Message.getFieldWithDefault(msg, 12, ""),
pageSizeCorrectionFactor: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
acknowledgeWarnings: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest;
  return proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.deserializeBinaryFromReader);
      msg.setScope(value);
      break;
    case 5:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PagePoint;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoordinateSystem(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnteredValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    case 10:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.deserializeBinaryFromReader);
      msg.setAutomaticCandidate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpectedEtag(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpectedPageRevision(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPageSizeCorrectionFactor(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAcknowledgeWarnings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getScope();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope.serializeBinaryToWriter
    );
  }
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PagePoint.serializeBinaryToWriter
    );
  }
  f = message.getCoordinateSystem();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEnteredValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAutomaticCandidate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate.serializeBinaryToWriter
    );
  }
  f = message.getExpectedEtag();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getExpectedPageRevision();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPageSizeCorrectionFactor();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getAcknowledgeWarnings();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional ScaleScope scope = 4;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getScope = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope, 4));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.ScaleScope|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setScope = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.clearScope = function() {
  return this.setScope(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.hasScope = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PagePoint start = 5;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getStart = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, 5));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.hasStart = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PagePoint end = 6;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getEnd = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PagePoint, 6));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PagePoint|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string coordinate_system = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getCoordinateSystem = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setCoordinateSystem = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string entered_value = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getEnteredValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setEnteredValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string note = 9;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional AutomaticScaleCandidate automatic_candidate = 10;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getAutomaticCandidate = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate, 10));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.AutomaticScaleCandidate|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setAutomaticCandidate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.clearAutomaticCandidate = function() {
  return this.setAutomaticCandidate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.hasAutomaticCandidate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string expected_etag = 11;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getExpectedEtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setExpectedEtag = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string expected_page_revision = 12;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getExpectedPageRevision = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setExpectedPageRevision = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional double page_size_correction_factor = 13;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getPageSizeCorrectionFactor = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setPageSizeCorrectionFactor = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional bool acknowledge_warnings = 14;
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.getAcknowledgeWarnings = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.SetPageScaleCalibrationRequest.prototype.setAcknowledgeWarnings = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
expectedEtag: jspb.Message.getFieldWithDefault(msg, 4, ""),
note: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest;
  return proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpectedEtag(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getExpectedEtag();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string expected_etag = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.getExpectedEtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.setExpectedEtag = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string note = 5;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ResetPageScaleCalibrationRequest.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
outcome: jspb.Message.getFieldWithDefault(msg, 1, 0),
state: (f = msg.getState()) && proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.toObject(includeInstance, f),
warningsList: jspb.Message.toObjectList(msg.getWarningsList(),
    proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.toObject, includeInstance),
message: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse;
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteOutcome} */ (reader.readEnum());
      msg.setOutcome(value);
      break;
    case 2:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.deserializeBinaryFromReader);
      msg.setState(value);
      break;
    case 3:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.deserializeBinaryFromReader);
      msg.addWarnings(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOutcome();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState.serializeBinaryToWriter
    );
  }
  f = message.getWarningsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning.serializeBinaryToWriter
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional PageScaleWriteOutcome outcome = 1;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteOutcome}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.getOutcome = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteOutcome} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteOutcome} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.setOutcome = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional PageScaleState state = 2;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.getState = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState, 2));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleState|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.setState = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.clearState = function() {
  return this.setState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.hasState = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated ScaleWarning warnings = 3;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning>}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.getWarningsList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning, 3));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning>} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.setWarningsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.addWarnings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.org.codetricks.construction.code.assistant.pagescale.ScaleWarning, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.clearWarningsList = function() {
  return this.setWarningsList([]);
};


/**
 * optional string message = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteResponse.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
revision: jspb.Message.getFieldWithDefault(msg, 1, 0),
etag: jspb.Message.getFieldWithDefault(msg, 2, ""),
action: jspb.Message.getFieldWithDefault(msg, 3, 0),
actor: jspb.Message.getFieldWithDefault(msg, 4, ""),
occurredAt: (f = msg.getOccurredAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
calibration: (f = msg.getCalibration()) && proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.toObject(includeInstance, f),
replacedCalibrationId: jspb.Message.getFieldWithDefault(msg, 7, ""),
note: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry;
  return proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRevision(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEtag(value);
      break;
    case 3:
      var value = /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleAction} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setActor(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setOccurredAt(value);
      break;
    case 6:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.deserializeBinaryFromReader);
      msg.setCalibration(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setReplacedCalibrationId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNote(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRevision();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEtag();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getActor();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOccurredAt();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCalibration();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration.serializeBinaryToWriter
    );
  }
  f = message.getReplacedCalibrationId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNote();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional int32 revision = 1;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getRevision = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setRevision = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string etag = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getEtag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setEtag = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PageScaleAction action = 3;
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleAction}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getAction = function() {
  return /** @type {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleAction} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleAction} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string actor = 4;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getActor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setActor = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp occurred_at = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getOccurredAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setOccurredAt = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.clearOccurredAt = function() {
  return this.setOccurredAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.hasOccurredAt = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PageScaleCalibration calibration = 6;
 * @return {?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getCalibration = function() {
  return /** @type{?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration} */ (
    jspb.Message.getWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration, 6));
};


/**
 * @param {?proto.org.codetricks.construction.code.assistant.pagescale.PageScaleCalibration|undefined} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setCalibration = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.clearCalibration = function() {
  return this.setCalibration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.hasCalibration = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string replaced_calibration_id = 7;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getReplacedCalibrationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setReplacedCalibrationId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string note = 8;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.getNote = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.prototype.setNote = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
projectId: jspb.Message.getFieldWithDefault(msg, 1, ""),
fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest;
  return proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional string project_id = 1;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
entriesList: jspb.Message.toObjectList(msg.getEntriesList(),
    proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse;
  return proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry;
      reader.readMessage(value,proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.deserializeBinaryFromReader);
      msg.addEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PageScaleHistoryEntry entries = 1;
 * @return {!Array<!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry>}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.prototype.getEntriesList = function() {
  return /** @type{!Array<!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry, 1));
};


/**
 * @param {!Array<!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry>} value
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse} returns this
*/
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.prototype.setEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.prototype.addEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.org.codetricks.construction.code.assistant.pagescale.PageScaleHistoryEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse} returns this
 */
proto.org.codetricks.construction.code.assistant.pagescale.ListPageScaleCalibrationHistoryResponse.prototype.clearEntriesList = function() {
  return this.setEntriesList([]);
};


/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.ScaleSource = {
  SCALE_SOURCE_UNSPECIFIED: 0,
  MANUAL_REFERENCE_DISTANCE: 1,
  AUTOMATIC_TRANSCRIPT: 2
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.LengthUnit = {
  LENGTH_UNIT_UNSPECIFIED: 0,
  LENGTH_UNIT_INCH: 1,
  LENGTH_UNIT_FOOT: 2,
  LENGTH_UNIT_FOOT_INCH: 3,
  LENGTH_UNIT_MILLIMETER: 4,
  LENGTH_UNIT_CENTIMETER: 5,
  LENGTH_UNIT_METER: 6
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleStatus = {
  PAGE_SCALE_STATUS_UNSPECIFIED: 0,
  AUTOMATIC: 1,
  MANUAL_ACTIVE: 2,
  MANUAL_INVALIDATED_PAGE_CHANGED: 3
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleWriteOutcome = {
  PAGE_SCALE_WRITE_OUTCOME_UNSPECIFIED: 0,
  APPLIED: 1,
  CONFLICT: 2,
  NEEDS_CONFIRMATION: 3,
  PAGE_CHANGED: 4
};

/**
 * @enum {number}
 */
proto.org.codetricks.construction.code.assistant.pagescale.PageScaleAction = {
  PAGE_SCALE_ACTION_UNSPECIFIED: 0,
  CALIBRATED: 1,
  RESET_TO_AUTOMATIC: 2
};

goog.object.extend(exports, proto.org.codetricks.construction.code.assistant.pagescale);
